import { render } from "./CxIcon.vue?vue&type=template&id=6bd5a8ae"
import script from "./CxIcon.vue?vue&type=script&lang=js"
export * from "./CxIcon.vue?vue&type=script&lang=js"

import "./CxIcon.vue?vue&type=style&index=0&id=6bd5a8ae&lang=less"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__